export enum ProxyType {
    socks4 = 0,
    socks4a = 1,
    socks5 = 2,
    http = 3
}
export namespace ProxyType{
    export function getName(value: ProxyType): string {
        switch (value) {
            case ProxyType.socks4:
                return "socks4";
            case ProxyType.socks4a:
                return "socks4a";
            case ProxyType.socks5:
                return "socks5";
            case ProxyType.http:
                return "http";
        }
    }
}
